<template>
  <CCardHeader class="pageHeader d-flex flex-column justify-content-between py-5 px-0 bg-transparent">
    <div>
      <h1 class="pageHeader__title mb-4">
        {{ title }}
      </h1>
      <p style="max-width: 70%; margin: 0 auto">
        {{ subTitle }}
      </p>
    </div>
    <div>
      <router-link :to="{ name: pathName }" v-if="TextPathName" class="text-decoration-none text-uppercase d-flex align-items-center text-gray-600">
        <CIcon name="arrow" :height="17" class="icon__rotateLeft mr-3" viewBox="0 0 32 32" />
        {{ $t(`general.${TextPathName}`) }}
      </router-link>
    </div>
  </CCardHeader>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    pathName: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    TextPathName: {
      type: String,
      required: false,
    },
  },
}
</script>

<style></style>
